document.addEventListener("DOMContentLoaded", () => {
  // Button im 'product-action' Bereich
  const addButton1 = document.querySelector(
    '.product-action button[name="add"]'
  );
  // Button im 'stickyCart' Bereich
  const addButton2 = document.querySelector('.stickyCart button[name="add"]');

  if (!addButton1 || !addButton2) {
    console.error("One or both buttons not found!");
    return;
  }

  // Funktion zur Anwendung der Namenänderung und Rücksetzung
  function modifyAndResetNames(button) {
    button.addEventListener("click", () => {
      const elements = document.querySelectorAll(
        "#configuratorContent input, #configuratorContent select, #configuratorContent textarea"
      );
      const originalNames = [];

      // Namen ändern
      elements.forEach((element, index) => {
        originalNames[index] = element.name; // Ursprünglichen Namen speichern
        element.name = `properties[${element.name}]`; // Namen ändern
      });

      // alert("Formularnamen wurden aktualisiert. Rückgängig in einer Sekunde.");

      // Namen nach 1 Sekunde zurücksetzen
      setTimeout(() => {
        elements.forEach((element, index) => {
          element.name = originalNames[index]; // Namen zurücksetzen
        });

        // alert("Änderungen wurden rückgängig gemacht.");
      }, 100); // 100 Millisekunden Verzögerung
    });
  }

  // Anwendung der Funktion auf beide Buttons
  modifyAndResetNames(addButton1);
  modifyAndResetNames(addButton2);
});

document.addEventListener("DOMContentLoaded", () => {
  const submitButton = document.querySelector(
    'button[name="configuratorForm"]'
  );
  let timeoutId = null;

  if (!submitButton) {
    console.error("Submit button not found!");
    return;
  }

  console.log("Submit Button found:", submitButton);

  // Listener für `change`-Events auf Checkboxen, Radiobuttons und Selects
  document.body.addEventListener("change", (event) => {
    const target = event.target;
    if (
      target.type === "radio" ||
      target.type === "checkbox" ||
      target.tagName.toLowerCase() === "select"
    ) {
      console.log("Option changed:", target.name);
      submitButton.click();
    }
  });

  // Funktion zum Debouncen der Eingaben für text und number Inputs
  function handleInput(event) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      console.log("Input debounced:", event.target.name);
      submitButton.click();
    }, 200);
  }

  // Listener für `input`-Events auf Number- und Textfeldern
  document.body.addEventListener("input", (event) => {
    const target = event.target;
    if (target.type === "number" || target.type === "text") {
      handleInput(event);
    }
  });

  // Listener für `blur`-Events, um sofort zu reagieren, wenn der Benutzer das Feld verlässt
  document.body.addEventListener(
    "blur",
    (event) => {
      const target = event.target;
      if (target.type === "number" || target.type === "text") {
        console.log("Input blurred:", target.name);
        submitButton.click();
      }
    },
    true
  );
});

// Filtermenu Sören
document.addEventListener("DOMContentLoaded", function () {
  // Überprüfen, ob das Hauptinhalt-Element die Klasse "collection" enthält
  const mainContent = document.querySelector(".main-content.collection");

  if (mainContent) {
    function updateFilterButtonText() {
      const filterButton = document.querySelector(".btn.btn-filter");
      const link = document.querySelector(".widget-content a.btn-link");
      const filtersToolbar = document.querySelector(".filters-toolbar");
      const existingFilter = document.querySelector(".filter-is-active");

      if (filterButton && link && filtersToolbar) {
        if (link.href !== "#") {
          filterButton.textContent = "Es ist ein Filter aktiv";

          if (!existingFilter) {
            const alertDiv = `
              <div class="filter-is-active" style="padding: 10px; margin: 0 0 20px; border: 3px solid #000; text-align: center;">
                <p>Es ist ein Filter aktiv! Hier <a class="btn-filter" href="#">ändern</a> oder alle Filter <a class="btn-filter" href="*">entfernen</a>!</p>
              </div>`;
            filtersToolbar.insertAdjacentHTML("afterend", alertDiv);
          }
        } else {
          filterButton.textContent = "Filter";

          if (existingFilter) {
            existingFilter.remove();
          }
        }
      }
    }

    // Initiale Überprüfung bei Laden der Seite
    updateFilterButtonText();

    // Event-Listener für Klicks auf der gesamten Seite
    document.body.addEventListener("click", function () {
      updateFilterButtonText();
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const faqContainer = document.querySelector('.faq-body');
  
  if (faqContainer) {
    faqContainer.addEventListener('click', function(event) {
      const clickedSummary = event.target.closest('summary');
      
      if (clickedSummary) {
        const clickedDetail = clickedSummary.parentElement;
        const allDetails = faqContainer.querySelectorAll('details');
        
        allDetails.forEach(detail => {
          if (detail !== clickedDetail) {
            detail.removeAttribute('open');
          }
        });
      }
    });
  }
});

// AA-Olli - Productpage Buybox Collapsable Tabs öffnen/schließen
document.addEventListener("DOMContentLoaded", function () {
    const sumtabs = document.querySelectorAll("details.sumtabs");
    
    sumtabs.forEach(tab => {
        tab.addEventListener("toggle", function () {
            if (tab.open) {
                sumtabs.forEach(otherTab => {
                    if (otherTab !== tab) {
                        otherTab.removeAttribute("open");
                    }
                });
            }
        });
    });
});

// AA-Olli Aktuelles Jahr
// function updateCurrentYear() {
//     const currentYear = new Date().getFullYear();
//     const yearElement = document.querySelector('.aa-current-year');
//     if (yearElement) {
//         yearElement.textContent = currentYear;
//     } else {
//         console.error('Element mit der Klasse \'aa-current-year\' nicht gefunden');
//     }
// }
// document.addEventListener('DOMContentLoaded', updateCurrentYear);